import React from 'react';
import { SvgIcon } from '@mui/material';

const SearchIcon = ({ ...props }) => (
    <SvgIcon
        {...props}
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M31.533 27.48L39.585 35.3055C40.7625 36.4515 40.809 38.3565 39.6915 39.5625C38.5725 40.7685 36.7125 40.818 35.535 39.672L27.4335 31.8615C25.0755 33.5235 22.224 34.4985 19.1475 34.4985C11.058 34.4985 4.5 27.7815 4.5 19.5C4.5 11.217 11.058 4.5 19.1475 4.5C27.2355 4.5 33.7935 11.217 33.7935 19.5C33.7935 22.4355 32.958 25.167 31.533 27.48ZM19.1475 8.40898C13.1655 8.40898 8.31746 13.374 8.31746 19.5C8.31746 25.6245 13.1655 30.5895 19.1475 30.5895C25.128 30.5895 29.976 25.6245 29.976 19.5C29.976 13.374 25.128 8.40898 19.1475 8.40898Z"
            fill="#111111"
        />
    </SvgIcon>
);

export default SearchIcon;
